import { render, staticRenderFns } from "./cliente-file-context.vue?vue&type=template&id=36b76e7c"
import script from "./cliente-file-context.vue?vue&type=script&lang=js"
export * from "./cliente-file-context.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports